import React from 'react';
import { useSelector } from 'react-redux';

import { DatePicker } from 'ui-components/components/date-picker';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './style.module.css';
import Global from '../../../../../../store/global-selectors';

/**
 * @param {object} props
 * @param {string} [props.expirationDate]
 * @param {(value: string) => void} props.setExpirationDate
 * @returns {JSX.Element}
 */

export const ExpirationDateInput = ({ expirationDate = '', setExpirationDate }) => {
  const userDateFormatString = useSelector(Global.selectUserUserDateFormat);

  return (
    <div className={style['input-wrapper']}>
      <Text textType={TextType.Label} value={messages.addToLocationExpirationDateLabel} />
      <DatePicker
        allowPastDates
        className={style['date-picker']}
        dateFormat={userDateFormatString}
        onChange={setExpirationDate}
        placeholder=''
        shouldInputHaveFullWidth
        value={expirationDate}
      />
    </div>
  );
};
